export default {
  ambassador: "Ambassadors' Gallery",
  merchaindise: 'Merchandise Collection',
  ShotonOPPO: 'ShotonOPPO Display',
  contentCenter: 'Ambassadors',
  ShotonOnePlus: 'Shot on OnePlus Monthly',
  spotlight: 'Spotlight'
}